import 'plyr-react/plyr.css';
import './antd-theme/antd-customized.css';
import './App.css';

import { createBrowserHistory } from 'history';
import {
  createBrowserRouter,
  RouterProvider,
} from 'react-router-dom';

import { CatalogVacancies } from './pages/CatalogVacancies';
import MainPage from './pages/MainPage';
import News from './pages/News';
import Office from './pages/Office';
import OperationsPage from './pages/OperationsPage';
import Page404 from './pages/Page404';
import Tech from './pages/Tech';
import VacancyPage from './pages/VacancyPage';

export const history = createBrowserHistory();

export const router = createBrowserRouter([
  {
    path: '/',
    element: <MainPage />,
    errorElement: <Page404 />,
  },
  {
    path: '/news',
    element: <News />,
  },
  {
    path: '/news/:division',
    element: <News />,
  },
  {
    path: '/office',
    element: <Office />,
  },
  {
    path: '/vacancies/:vacancyFriendlyUrl',
    element: <VacancyPage />,
  },
  {
    path: '/vacancies/id/:vacancyIdForUrl',
    element: <VacancyPage />,
  },
  {
    path: '/operations',
    element: <OperationsPage />,
  },
  {
    path: '/tech',
    element: <Tech />,
  },
  {
    path: '/catalog-vacancies',
    element: <CatalogVacancies />,
  },
]);

export function App() {
  return (
    <RouterProvider router={router} />
  );
}
